
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import API from '@/lib/API';
import {
  Lead, User, LeadStatus, LeadType,
} from '@/types';
import LeadEraseDialog from '@/components/LeadEraseDialog.vue';
// import LeadReopenDialog from '@/components/LeadReopenDialog.vue';
import LeadConvertDialog from '@/components/LeadConvertDialog.vue';
import LeadRelinkDialog from '@/components/LeadRelinkDialog.vue';
import LeadRuleTesterDialog from '@/components/LeadRuleTesterDialog.vue';

@Component({
  components: {
    LeadEraseDialog,
    // LeadReopenDialog,
    LeadConvertDialog,
    LeadRelinkDialog,
    LeadRuleTesterDialog,
  },
})
export default class LeadSuperActions extends Vue {
  @Prop(Boolean) readonly loading!: boolean;

  eraseDialog = false
  // reopenDialog = false
  convertDialog = false
  relinkDialog = false
  testRulesDialog = false
  ghostCleanupLoading = false

  conversion = {} as {
    version?: number;
    type?: LeadType;
    extra?: string;
  };

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get version(): number | false {
    return this.lead
      && 'version' in this.lead
      && this.lead.version ? this.lead.version : false;
  }

  get status(): LeadStatus {
    return this.lead.status;
  }

  get closed(): boolean {
    return this.lead && this.status === 'closed';
  }

  get resolved(): boolean {
    return this.lead && this.status === 'resolved';
  }

  get rejected(): boolean {
    return this.lead && this.status === 'rejected';
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get isSuperUser(): boolean {
    return this.user && this.user.isSuperUser;
  }

  get noTaskCm(): boolean {
    if (!this.lead || 'Tasks' in this.lead === false) return false;

    let found = false;

    this.lead.Tasks.forEach((task) => {
      if (['Cm'].includes(task.name)) found = true;
    });

    return !found;
  }

  get noTaskV(): boolean {
    if (!this.lead || 'Tasks' in this.lead === false) return false;

    let found = false;

    this.lead.Tasks.forEach((task) => {
      if (['V'].includes(task.name)) found = true;
    });

    return !found;
  }

  onErase() {
    console.log('LeadSuperActions: onErase()'); // eslint-disable-line no-console

    this.eraseDialog = true;
  }

  // onReopen() {
  //   console.log('LeadSuperActions: onReopen()'); // eslint-disable-line no-console

  //   this.reopenDialog = true;
  // }

  onConvert(version, type, extra: string | null = null) {
    console.log('LeadSuperActions: onConvert()'); // eslint-disable-line no-console

    this.$set(this.conversion, 'version', version);
    this.$set(this.conversion, 'type', type);
    this.$set(this.conversion, 'extra', extra);

    this.convertDialog = true;
  }

  onRelink() {
    console.log('LeadSuperActions: onRelink()'); // eslint-disable-line no-console

    this.relinkDialog = true;
  }

  onTestRules() {
    console.log('LeadSuperActions: onTestRules()'); // eslint-disable-line no-console

    this.testRulesDialog = true;
  }

  async onGhostTasksCleanup() {
    if (!this.lead || this.ghostCleanupLoading) return;

    this.ghostCleanupLoading = true;
    try {
      await API.leadGhostTasksCleanup(this.lead.id);
      await this.$store.dispatch('selectLead', { id: this.lead.id });
    } catch (err) {
      console.error('LeadSuperActions: onGhostTasksCleanup error', err);
    } finally {
      this.ghostCleanupLoading = false;
    }
  }
}
